import url from './url';



export default url(({ logId = ':logId' }) => `/rbac/logs/${logId}`);
